export var SearchBoxDisplayModes;
(function (SearchBoxDisplayModes) {
    SearchBoxDisplayModes["Default"] = "DEFAULT";
    SearchBoxDisplayModes["Compact"] = "COMPACT";
})(SearchBoxDisplayModes || (SearchBoxDisplayModes = {}));
//# sourceMappingURL=display-modes.js.map